import{css as t,LitElement as e}from"lit";export const globals=t`
  h4 {
    margin: 0;
    padding-bottom: var(--lumo-space-m);
    font-size: var(--lumo-font-size-l);
    font-weight: 600;
    line-height: 125.303%;
  }
`;export class OrElement extends e{static finalizeStyles(t){return[globals,...super.finalizeStyles(t)]}}